import * as Yup from 'yup';

import { entityNameValidator } from '@zen/Accounts/validations';

const updateAccountNameFormValidation = Yup.object({
  tradingName: entityNameValidator('Company name')
}).required();

export { updateAccountNameFormValidation };
